'use strict';

import React, { Component } from 'react';
import InvoiceFinancingProcess  from './invoiceFinancingProcess';
import { withStyles } from '@material-ui/styles';
import { CssBaseline, Grid, Button, Box, ThemeProvider, Container, Typography, Hidden } from '@material-ui/core';
import theme from '../../theme/theme';
import { COLOR_WHITE, COLOR_KASVU_BLUE, COLOR_KASVU_THEME_LIGHT, COLOR_TEXT_BLUE, TYPOGRAPHY_BODY_SMALL_WEIGHT } from '../../theme/tokens';
import logo from '../../img/logo.svg';
import logoLight from '../../img/logo-light.svg';


const styles = theme => ({
  topBar: {
    backgroundColor: COLOR_TEXT_BLUE,
    padding: 10,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navigationBar: {
    display: 'flex',
    padding: '28px 56px',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: COLOR_KASVU_THEME_LIGHT,
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  logo: {
    height: theme.spacing(5),
  },
  pageBackground: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLOR_WHITE,

    '&::before': {
      display: 'block',
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '50%',
      maxHeight: theme.spacing(1) * 72,
      backgroundColor: COLOR_KASVU_THEME_LIGHT,
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 40%, 0% 100%)',
      zIndex: 0,
    },

    '& > *': {
      zIndex: 1,
    },
  },
  footer: {
    backgroundColor: COLOR_KASVU_BLUE,
    marginTop: theme.spacing(19),
    padding: '128px 0',
    textAlign: 'left',
    [theme.breakpoints.down('lg')]: {
      padding: '56px 20px',
    },
  },
  footerLogo: {
    height: 33,
    marginBottom: 10,
  },
  footerGroupTitle: {
    letterSpacing: '0.01em',
    color: 'rgba(255,255,255,0.6)',
    fontSize: 14,
    lineHeight: '26px',
  },
  footerLink: {
    fontWeight: TYPOGRAPHY_BODY_SMALL_WEIGHT,
    letterSpacing: '0.01em',
    color: COLOR_WHITE,
    fontSize: 14,
    lineHeight: '26px',
    '&:hover': {
      color: COLOR_WHITE,
    },
  },
});

class UnstyledInvoiceFinancing extends Component {
  componentDidMount() {
    document.title = 'Avaa laskurahoitus';
  }

  render() {
    const { classes } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Box className={classes.topBar}>
          <Typography variant='subtitle2' style={{ color: COLOR_WHITE }}>
            Laskurahoitus 2 minuutissa, vapauta sidottu pääoma välittömästi!
          </Typography>
        </Box>
        <Box className={classes.navigationBar}>
          <Button className={classes.logo} href='https://www.kasvurahoitus.fi/'>
            <img src={logo} />
          </Button>

          <Box>
            <Button href='tel:0968298003' variant='contained' color='primary' size='small'>
              Ota yhteyttä: <Hidden smUp><br /></Hidden>09 6829 8003
            </Button>
          </Box>
        </Box>

        <Box className={classes.pageBackground}>
          <Container maxWidth='lg'>
            <InvoiceFinancingProcess authUserId={this.props.match} search={this.props.history.location.search} />

          </Container>



          <Box className={classes.footer}>
            <Container maxWidth='lg'>
              <Box style={{ textAlign: 'center' }}>
              <div style={{marginBottom: "25px"}} class="trustpilot-widget" data-locale="fi-FI" data-template-id="5406e65db0d04a09e042d5fc" 
              data-businessunit-id="607582d37881d800016abf4e" data-style-height="28px" data-style-width="100%" data-theme="dark" data-tags="SelectedReview" data-font-family="Noto Sans">
  <a href="https://fi.trustpilot.com/review/kasvurahoitus.fi" target="_blank" rel="noopener">Trustpilot</a>
</div>
                <a href='https://kasvurahoitus.fi'>
                  <img src={logoLight} className={classes.footerLogo} />
                </a>
                <Typography>
                  <a href='tel:0968298003' style={{ color: COLOR_WHITE }}>09 6829 8003</a>
                </Typography>
                <Typography>
                  <a href='mailto:laskurahoitus@kasvurahoitus.fi' style={{ color: COLOR_WHITE }}>laskurahoitus@kasvurahoitus.fi</a>
                </Typography>
              </Box>
            </Container>
          </Box>
        </Box>
      </ThemeProvider>
    )
  }
};

/** 
 * withStyles imported from @material-ui/core/styles comes with a default theme, NOT the customized theme provided in the provider
 * withStyles imported from @material-ui/styles WILL use the customized theme but it has to be wrapped inside the theme provider
 */
const StyledInvoiceFinancing = withStyles(styles)(UnstyledInvoiceFinancing);

const InvoiceFinancing = props => (
  <ThemeProvider theme={theme}>
    <CssBaseline />

    <StyledInvoiceFinancing {...props} />
  </ThemeProvider>
);

export default InvoiceFinancing;
